import { Route, Routes } from "react-router-dom";
import Calendar from "./pages/calendar";
import DashboardIndex from "./layouts/DashboardIndex";
import Home from "./pages/home";
import Learning from "./pages/learning";
import WishList from "./pages/wishlist";
import CourseSingle from "./pages/course-single";
import ProgramSingle from "./pages/program-single"
import Progress from "./pages/progress";
import Discover from './pages/discover';
import CoursesDiscover from "./pages/discover/courses-discover";
import ProgramsDiscover from "./pages/discover/programs-discover";
import LearnerProgram from "./pages/learning/learner-program";
import Notifications from "./pages/notifications";
import Support from "./pages/support";
import Organizations from "./pages/organizations";
import ViewTicket from "./pages/support/view-ticket";

const AllRoutes = () => {
    return (
        <Routes>
            <Route element={<DashboardIndex />} >
                <Route path="/" element={<Home />} />
                <Route path="/learning" element={<Learning />} />
                <Route path="learning/learner-program/:id" element={<LearnerProgram />} />
                <Route path="/course/:id" element={<CourseSingle />} />
                <Route path="/program/:id" element={<ProgramSingle />} />
                <Route path="/progress" element={<Progress />} />
                <Route path="/wishlist" element={<WishList />} />
                <Route path="/calendar" element={<Calendar />} />
                <Route path="/discover" element={<Discover />} />
                <Route path="/discover/courses" element={<CoursesDiscover />} />
                <Route path="/discover/programs" element={<ProgramsDiscover />} />
                <Route path="/notifications" element={<Notifications />} />
                <Route path="/support" element={<Support />} />
                <Route path="/support/view-ticket/:ticketId" element={<ViewTicket />} />
            </Route>
            <Route path="/organizations" element={<Organizations />} />
        </Routes>
    )
}

export default AllRoutes;